import React from "react";
import { Controller } from "react-hook-form";

import { DSTextarea } from "../design-system/molecules";

export default function HeaderTextBox({ control, setIsEditing }) {
  return (
    <div className="flex flex-1 flex-row items-center space-x-4">
      <Controller
        name={"headerInfoPdf"}
        control={control}
        rules={{ required: false, minLength: 1 }}
        render={({ field: { onChange, value } }) => (
          <DSTextarea
            minRows={4}
            placeholder="Enter clinic name, address, email, phone number, etc."
            onChange={(e) => onChange(e)}
            value={value ?? ""}
            onFocus={() => setIsEditing(true)}
            dataTestId="header-text-box"
          />
        )}
      />
    </div>
  );
}
